import { render, staticRenderFns } from "./e-organization-owner.vue?vue&type=template&id=6ddbcc04&scoped=true&lang=pug"
import script from "./e-organization-owner.vue?vue&type=script&lang=js"
export * from "./e-organization-owner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddbcc04",
  null
  
)

export default component.exports